import 'vscode/vscode/vs/platform/accessibilitySignal/browser/accessibilitySignalService';
import 'vscode/vscode/vs/platform/instantiation/common/instantiation';
import { registerAction2 } from 'vscode/vscode/vs/platform/actions/common/actions';
import { registerWorkbenchContribution2 } from 'vscode/vscode/vs/workbench/common/contributions';
import { AccessibilitySignalLineDebuggerContribution } from './accessibilitySignalDebuggerContribution.js';
import { ShowSignalSoundHelp, ShowAccessibilityAnnouncementHelp } from './commands.js';
import { EditorTextPropertySignalsContribution } from './editorTextPropertySignalsContribution.js';
import { wrapInReloadableClass } from './reloadableWorkbenchContribution.js';

registerWorkbenchContribution2('EditorTextPropertySignalsContribution', wrapInReloadableClass(() => EditorTextPropertySignalsContribution), 3 );
registerWorkbenchContribution2('AccessibilitySignalLineDebuggerContribution', AccessibilitySignalLineDebuggerContribution, 3 );
registerAction2(ShowSignalSoundHelp);
registerAction2(ShowAccessibilityAnnouncementHelp);
